var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 14.0088V34.528C36.25 35.3054 35.9866 36.051 35.5178 36.6007C35.0489 37.1504 34.413 37.4593 33.75 37.4593H6.25C5.58696 37.4593 4.95107 37.1504 4.48223 36.6007C4.01339 36.051 3.75 35.3054 3.75 34.528V14.0088M36.25 14.0088C36.25 13.2314 35.9866 12.4858 35.5178 11.936C35.0489 11.3863 34.413 11.0775 33.75 11.0775H6.25C5.58696 11.0775 4.95107 11.3863 4.48223 11.936C4.01339 12.4858 3.75 13.2314 3.75 14.0088M36.25 14.0088L21.4225 26.0448C21.0045 26.3839 20.5083 26.5655 20 26.5655C19.4917 26.5655 18.9955 26.3839 18.5775 26.0448L3.75 14.0088",
    stroke: "#2f5159",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.b7985c2be307e1785b7cf336b96383c9.svg";
export { ForwardRef as ReactComponent };